export function setCookie(name, value) {
  document.cookie = `${name}=${value}`;
}
export function hasCookie(name) {
  return document.cookie.split(';').some(item => item.trim().startsWith(`${name}=`));
}
export function removeCookie(name) {
  if (hasCookie(name)) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  }
}
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    var _parts$pop;
    return (_parts$pop = parts.pop()) == null ? void 0 : _parts$pop.split(';').shift();
  }
  return false;
}
//# sourceMappingURL=cookie.js.map